import { Cookie } from "@modules/util/Cookie.ts"
const cookieName = "hideLoginNotice"

function hideLoginNotice() {
    document.getElementById("login-notice-stripe")?.classList.add("hidden")
}

const closeLoginNotice = () => {
    hideLoginNotice()
    new Cookie(cookieName, {
        path: "/",
        domain: SiteInfo.cookieDomain,
        expires: Cookie.getExpireDate(3600 * 24 * 30), // 30 days
        value: 1,
    })
}

const loginNoticeClose = document.getElementById("login-notice-stripe-close")
if (loginNoticeClose) {
    loginNoticeClose?.addEventListener("click", closeLoginNotice)
}
